import invariant from 'invariant';
import useConnections from './useConnections';

export default function useDeepLink() {
  const { sourceConnection, targetConnection } = useConnections();

  function getDeepLink(orgDomain: string, recordID: string) {
    return `${orgDomain}/${recordID}`;
  }

  function getDeepLinkForSource(recordID: string) {
    invariant(sourceConnection.value !== null, 'Source Connection is `null`');
    return getDeepLink(sourceConnection.value.domain, recordID);
  }

  function getDeepLinkForTarget(recordID: string) {
    invariant(targetConnection.value !== null, 'Target Connection is `null`');
    return getDeepLink(targetConnection.value.domain, recordID);
  }

  return {
    getDeepLinkForSource,
    getDeepLinkForTarget,
  };
}
